export default __webpack_public_path__ + "static/media/nyc-scape.449f55de.jpg";